import { toInteger } from 'lodash';
import { getFlowRunLogsRetentionCutoff } from 'new/constants/retentionConstants';

/**
 * Priority 1: If runId exists and is a valid positive number (> 0), return runId timestamp
 * Priority 2: If createdAt exists and is valid AND strictly greater than the retention cutoff, return createdAt timestamp
 * Priority 3: Otherwise, return the retention cutoff timestamp
 */
export const calculateInitialDateRange = (
  runId: string | null | undefined,
  createdAt: string | null | undefined,
): number => {
  const THIRTY_DAYS_AGO_MS = getFlowRunLogsRetentionCutoff();

  if (runId) {
    const runIdTimestamp = toInteger(runId);
    if (runIdTimestamp > 0) {
      return runIdTimestamp;
    }
  }

  if (createdAt) {
    try {
      const createdAtTimestamp = new Date(createdAt).getTime();
      if (!isNaN(createdAtTimestamp) && createdAtTimestamp > THIRTY_DAYS_AGO_MS) {
        return createdAtTimestamp;
      }
    } catch (error) {
      console.error('Error parsing createdAt', error);
    }
  }

  return THIRTY_DAYS_AGO_MS;
};
